import React from "react";
import { FaArrowCircleRight } from "react-icons/fa";
import { IoChatboxEllipses, IoChatbubble } from "react-icons/io5";
import { MdChargingStation } from "react-icons/md";

const WhyPartner = () => {
  return (
    <section className="benefits" id="benefits">
      <div className="benifits-header">
        <span>Features</span>
        <h2>Why Partner with Shophr</h2>
        <p>
          Powerful, self-serve product and growth analytics to help you convert,
          engage and <br /> retain more customers
        </p>
      </div>

      <div className="benefits-grid">
        <div className="benefit">
          <IoChatboxEllipses className="icon" />
          <h3>Manage Clothing Deliveries Together</h3>
          <p>
            No matter if your team is small or large, our shared clothing
            delivery system ensures everyone stays informed and coordinated.
          </p>
          <span>
            Discover more about our delivery options.
            <FaArrowCircleRight />
          </span>
        </div>
        <div className="benefit">
          <MdChargingStation className="icon" />
          <h3>Provide quick updates on your clothing orders.</h3>
          <p>
            A comprehensive clothing delivery platform designed to meet all your
            customers fashion needs.
          </p>
          <span>
            Explore additional details. <FaArrowCircleRight />
          </span>
        </div>
        <div className="benefit">
          <IoChatbubble className="icon" />
          <h3>Engage with customers about their clothing preferences.</h3>
          <p>
            Address inquries or finalize clothing orders instantly through chat.
            If no one is avaailable customers witll be directed to email
            support.
          </p>
          <span>
            Find out more about our services.
            <FaArrowCircleRight />
          </span>
        </div>
      </div>
    </section>
  );
};

export default WhyPartner;
